import React, { useState } from "react";
import { Button } from "../../../../_helpers/components/Button";
import { useOutletContext } from "react-router-dom";
import { attachShift, detachShift } from "../../../../_api/EventShift";
import { Badge } from "../../../../_helpers/components/Badge";
import { formatTime } from "../../../../_helpers/functions";
import toast from "react-hot-toast";

const mappingStatus = {
    CLOSED: "Fermé",
    CANCELLED: "Annulé",
    PENDING: "En cours",
};

const mappingInscriptionStatus = {
    REFUSED: { label: "Non retenu", color: "red" },
    ACCEPTED: { label: "Confirmé", color: "green" },
    PENDING: { label: "En attente", color: "blue" },
    WAITING_LIST: { label: "Attente", color: "orange" },
    WITHDRAWAL: { label: "Désistement", color: "red" },
};

export const EventUserView = ({ shifts, reloadEvent }) => {
    const [user, setUser] = useOutletContext();
    const [loadingShiftIds, setLoadingShiftIds] = useState([]);
    const [isSendingComment, setIsSendingComment] = useState(false);
    const [selectedShift, setSelectedShift] = useState(null); // pour ouvrir le modal
    const [commentText, setCommentText] = useState(""); // texte du commentaire
    const [viewCommentShift, setViewCommentShift] = useState(null); // shift dont on veut voir le commentaire
    const filteredShifts = shifts.filter((creneau) => {
        if (!creneau.skill_id || user.skills.some((s) => s.id === creneau.skill_id)) {
            return creneau;
        }
    });

    const groupedShifts = filteredShifts.reduce((acc, creneau) => {
        const dateKey = new Date(creneau.start_time).toLocaleDateString("fr-FR", {
            weekday: "long",
            day: "numeric",
            month: "long",
        });

        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(creneau);
        return acc;
    }, {});

    const startLoading = (id) => setLoadingShiftIds((ids) => [...ids, id]);
    const stopLoading = (id) => setLoadingShiftIds((ids) => ids.filter((sid) => sid !== id));

    // Handler envoyer le commentaire
    const handleSendComment = (selectedShift) => {
        const payload = {
            userID: user.id,
            shiftID: selectedShift.id,
            comment: commentText
        };
        setIsSendingComment(true);
        attachShift(payload)
            .then((resp) => {
                toast(resp.data.message);
                setUser(resp.data.data.user);
                reloadEvent();
                setCommentText("");
                setSelectedShift(null);
            })
            .finally(() => setIsSendingComment(false));
    };

    return (
        <div className="w-full space-y-6">
            {Object.entries(groupedShifts).map(([date, dayShifts]) => (
                <div key={date} className="bg-white p-4 rounded-lg shadow-sm">
                    <h2 className="text-lg font-bold text-gray-700 mb-4">{date}</h2>
                    <div className="flex flex-wrap gap-4">
                        {dayShifts.map((creneau) => {
                            const isLoading = loadingShiftIds.includes(creneau.id);
                            const shiftStatus = user.shifts.find((s) => s.id === creneau.id);
                            const isRegistered = shiftStatus;

                            return (
                                <div
                                    key={creneau.id}
                                    className="relative p-4 border rounded-lg bg-gray-50 text-center flex-initial min-w-min w-full md:w-56 pt-6"
                                >
                                    {creneau.comment && (
                                        <div className="absolute top-2 left-2">
                                            <button
                                                onClick={() => setViewCommentShift(creneau)}
                                                title="Voir les consignes"
                                                className="relative text-yellow-500 hover:text-yellow-700 flex gap-2"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="w-5 h-5 cursor-pointer"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth={2}
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 9v2m0 4h.01M12 2a10 10 0 110 20 10 10 0 010-20z"
                                                    />
                                                </svg>
                                                <span className="-ml-1 text-xs">+ d'info</span>
                                            </button>
                                        </div>
                                    )}



                                    {isRegistered && <button
                                        onClick={() => {
                                            setSelectedShift(creneau);
                                            setCommentText(shiftStatus?.pivot.comment);
                                        }}
                                        title="Ajouter un commentaire"
                                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-5 h-5"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M8.25 9.75h7.5m-7.5 3h3.75M21 12c0 4.418-4.03 8-9 8a9.77 9.77 0 01-4.5-1.07L3 19.5l1.57-3.14A7.978 7.978 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                            />
                                        </svg>
                                    </button>
                                    }
                                    <div className="text-center m-2">
                                        <Badge
                                            text={
                                                ["CANCELLED", "CLOSED"].includes(creneau.status)
                                                    ? mappingStatus[creneau.status]
                                                    : creneau?.skill?.description || "Ouvert\u00a0à\u00a0tous"
                                            }
                                            color={creneau?.skill?.description ? "blue" : "green"}
                                        />
                                    </div>
                                    <p className="font-semibold text-center mb-4">
                                        {formatTime(new Date(creneau.start_time))} {" - "}
                                        {formatTime(new Date(creneau.end_time))}
                                    </p>
                                    {!isRegistered && !["CANCELLED", "CLOSED"].includes(creneau.status) && (
                                        <Button
                                            type={"empty"}
                                            name="S'inscrire"
                                            loading={isLoading}
                                            action={() => {
                                                if (isLoading) return;
                                                startLoading(creneau.id);
                                                const payload = {
                                                    userID: user.id,
                                                    shiftID: creneau.id,
                                                };
                                                attachShift(payload)
                                                    .then((resp) => {
                                                        toast(resp.data.message);
                                                        setUser(resp.data.data.user);
                                                        reloadEvent();
                                                    })
                                                    .finally(() => stopLoading(creneau.id));
                                            }}
                                        />
                                    )}
                                    {isRegistered && !["CANCELLED", "CLOSED"].includes(creneau.status) && (
                                        <>
                                            <div>
                                                <Badge
                                                    text={mappingInscriptionStatus[shiftStatus?.pivot.status].label}
                                                    color={mappingInscriptionStatus[shiftStatus?.pivot.status].color}
                                                />
                                            </div>
                                            {!["ACCEPTED", "REFUSED", "WITHDRAWAL"].includes(shiftStatus?.pivot.status) && (
                                                <div className="mt-4">
                                                    <Button
                                                        type={"red"}
                                                        name="Se\u00a0désinscrire"
                                                        loading={isLoading}
                                                        isReadOnly={["CLOSED", "CANCELLED"].includes(creneau.status)}
                                                        action={() => {
                                                            if (isLoading) return;
                                                            startLoading(creneau.id);
                                                            const payload = {
                                                                userID: user.id,
                                                                shiftID: creneau.id,
                                                            };
                                                            detachShift(payload)
                                                                .then((resp) => {
                                                                    toast(resp.data.message);
                                                                    setUser(resp.data.data.user);
                                                                    reloadEvent();
                                                                })
                                                                .catch(() => {
                                                                    toast.error("Vous ne pouvez pas annuler votre inscription.");
                                                                })
                                                                .finally(() => stopLoading(creneau.id));
                                                        }}
                                                    />
                                                </div>
                                            )}

                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))
            }
            {viewCommentShift && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md">
                        <h3 className="text-lg font-semibold mb-4">Instruction pour cet évènement : </h3>
                        <p className="text-gray-700">{viewCommentShift.comment}</p>
                        <div className="flex justify-end mt-4">
                            <button
                                onClick={() => setViewCommentShift(null)}
                                className="px-4 py-2 rounded-sm bg-gray-200 hover:bg-gray-300"
                            >
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {
                selectedShift && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
                        <div className="bg-white rounded-lg p-6 w-full max-w-md">
                            <h3 className="text-lg font-semibold mb-4">
                                Ajouter un commentaire à votre inscription :
                            </h3>
                            <textarea
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                rows={4}
                                className="w-full border rounded-sm p-2 mb-4 focus:outline-hidden focus:ring-2 focus:ring-blue-500"
                                placeholder="Votre commentaire..."
                            ></textarea>
                            <div className="flex justify-end gap-2">
                                <Button
                                    name="Annuler"
                                    action={() => {
                                        setSelectedShift(null);
                                        setCommentText("");
                                    }}
                                    type="empty"
                                >
                                </Button>
                                <Button
                                    name="Envoyer"
                                    action={() => handleSendComment(selectedShift)}
                                    loading={isSendingComment}
                                >
                                </Button>
                            </div>
                        </div>
                    </div>
                )
            }
            {/* --- fin Modal commentaire --- */}
        </div >
    );
};
